import React, {FC, memo, useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, IRootState} from "../../store/configureStore";
import thermometer from "../../image/thermometer.svg"
import temperature from "../../image/temperature.svg"
import humidity from "../../image/humidity.svg"
import {ISensorTemperature} from "../../store/sliceWebsocket";
import {
    SensorTemperatureArticle,
    SensorTemperatureDiv,
    SensorTemperatureImg,
    SensorTemperatureText
} from "./SensorTemperatureStyle";
import {BatteryFull, BatteryHalf, BatteryLow} from "react-bootstrap-icons";


interface SensorTemperatureProps {
    deviceId: string
}

const SensorTemperature: FC<SensorTemperatureProps> = ({deviceId}) => {
    const dispatch = useDispatch<AppDispatch>();
    const iSensorTemperature: ISensorTemperature = useSelector((state: IRootState) => state.websocket.temperatureSensors.filter((sensor: ISensorTemperature) => sensor.deviceId === deviceId)[0])



    const battery = useCallback(() => {
        return <div style={{marginRight: "5px", display: "flex"}}>
            {(!iSensorTemperature?.battery || iSensorTemperature?.battery > 70) && <BatteryFull size={20}/>}
            {iSensorTemperature?.battery <= 70 && iSensorTemperature?.battery > 30 && <BatteryHalf size={20}/>}
            {iSensorTemperature?.battery <= 30 && <BatteryLow size={20}/>}
        </div>
    }, [iSensorTemperature?.battery])

    return (
        <SensorTemperatureArticle>
            <SensorTemperatureImg src={thermometer} alt={"Термометр"}/>
            {iSensorTemperature?.location && <SensorTemperatureText>{iSensorTemperature?.location}</SensorTemperatureText>}
            {!iSensorTemperature?.location && <SensorTemperatureText>--</SensorTemperatureText>}
            <SensorTemperatureDiv>
                {battery()}
                {iSensorTemperature?.battery && <span>{iSensorTemperature?.battery} %</span>}
                {!iSensorTemperature?.battery && <span>-- %</span>}
            </SensorTemperatureDiv>
            <SensorTemperatureDiv>
                <img src={temperature}/>
                {iSensorTemperature?.temperature && <span>{iSensorTemperature?.temperature} °C</span>}
                {!iSensorTemperature?.temperature && <span>-- °C</span>}
            </SensorTemperatureDiv>
            <SensorTemperatureDiv>
                <img src={humidity}/>
                { iSensorTemperature?.humidity && <span>{iSensorTemperature?.humidity} %</span>}
                { !iSensorTemperature?.humidity && <span>-- %</span>}
            </SensorTemperatureDiv>
        </SensorTemperatureArticle>
    )
}


export default memo(SensorTemperature)

